import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";


const initState = {
  locationId: '',
  organizationId: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  country: '',
};

const organizationAddressFormData = {
  name: "Organization Address Form",
  initialState: initState,
  section: [
    {
      sectionId: '"OrganizationAddress',
      title: "Organization Address Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "addressLine1",
          label: "Address Line 1",
          Field_Name: "addressline 1",
          fieldType: FormFieldTypes.INPUT,
          dataField: "addressLine1",
          fieldSetting: {
            placeholder: "Please Enter Address Line 1",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "addressLine2",
          label: "Address Line 2",
          Field_Name: "address line 2",
          fieldType: FormFieldTypes.INPUT,
          dataField: "addressLine2",
          fieldSetting: {
            placeholder: "Please Enter Address Line 2",
            allowSpace: true,
          },
          style: {
            containerCss: "col-lg-6 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "country",
          label: "Country",
          Field_Name: "country",
          fieldType: FormFieldTypes.INPUT,
          dataField: "country",
          fieldSetting: {
            placeholder: "Please Enter Country",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "state",
          label: "State",
          Field_Name: "state",
          fieldType: FormFieldTypes.INPUT,
          dataField: "state",
          fieldSetting: {
            placeholder: "Please Enter State",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "city",
          label: "City",
          Field_Name: "city",
          fieldType: FormFieldTypes.INPUT,
          dataField: "city",
          fieldSetting: {
            placeholder: "Please Enter City",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-1 validation-left-0",
          },
        },
      ]
    }
  ]
}


export default organizationAddressFormData;